// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"91f4b2c9","122":"cd4c47d3","315":"60d42346","393":"03ef512b","494":"50fb1ba0","591":"94f26e61","774":"1a0e30dc","787":"3dc6f05a","875":"af07ff79"}[chunkId] + ".chunk.js";
};